// extracted by mini-css-extract-plugin
export default {"models_bar":"modelsBar_models_bar__DvuAs"};